import { render } from "./BlockShiftModal.vue?vue&type=template&id=01b21595"
import script from "./BlockShiftModal.vue?vue&type=script&lang=js"
export * from "./BlockShiftModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__